import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import useAttestation from 'legacy/src/components/assessment/hooks/useAttestation';
import IconWithDescription from '../index';

import './styles.scss';

const questionText = 'This question appears on an official practice exam.';
const assessmentText = [
  'This assessment contains one or more',
  'questions from a secure practice exam.',
];

export const LABELS = {
  question: <span>{questionText}</span>,
  assessment: (
    <span>
      {assessmentText[0]}
      <br />
      {assessmentText[1]}
    </span>
  ),
};
const ARIA_LABELS = {
  question: questionText,
  assessment: assessmentText.join(' '),
};

const SecureInfo = ({
  isQuestion = true,
  showFullLabel = false,
  width = 'auto',
}) => {
  const { secureQuestionErrorText, secureMessageText } = useAttestation({});

  const type = isQuestion ? 'question' : 'assessment';

  const label = showFullLabel ? secureQuestionErrorText : LABELS[type];
  const ariaLabel = showFullLabel ? secureMessageText : ARIA_LABELS[type];

  return (
    <IconWithDescription
      className="secure_indicator"
      width={width}
      btnProps={{ shape: 'round', size: 'xsmall', color: 'light_blue' }}
      trigger={
        <Icon
          name="practice_question"
          height="20"
          width="20"
          className="flex items-center"
        />
      }
      popoverAriaLabel="secure"
      tooltipAriaLabel={ariaLabel}
      ariaLive="polite"
    >
      <span className="secure_indicator_text">{label}</span>
    </IconWithDescription>
  );
};

SecureInfo.displayName = 'SecureInfo';

export default SecureInfo;
